<template>
  <!-- Footer-->
  <footer class="footer text-center text-light">
    <div class="container-fluid">
      <div class="row d-flex justify-content-center">
        <!-- Footer Location-->
        <div class="col-lg-4 mb-lg-0 mt-5">
          <h4 class="text-uppercase mb-4">Location</h4>
          <p class="lead mb-0">
            Taguig City
            <br />
            Metro Manila, Philippines
          </p>
        </div>
        <!-- Footer Social Icons-->
        <div class="col-lg-4 mb-lg-0 mt-5">
          <h4 class="text-uppercase mb-4">Around the Web</h4>
          <a
            class="btn btn-outline-light btn-social mx-1"
            href="https://www.facebook.com/altheo.saqui/"
            ><i class="fab fa-fw fa-facebook-f"></i
          ></a>
          <a class="btn btn-outline-light btn-social mx-1" href="#!"
            ><i class="fab fa-fw fa-twitter"></i
          ></a>
          <a class="btn btn-outline-light btn-social mx-1" href="#!"
            ><i class="fab fa-fw fa-linkedin-in"></i
          ></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footer-content",
};
</script>

<style scope>
footer {
  height: 13rem;
}
</style>